import { render, staticRenderFns } from "./monev_left_sidebar.vue?vue&type=template&id=3f4c9cf8&"
import script from "./monev_left_sidebar.vue?vue&type=script&lang=js&"
export * from "./monev_left_sidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports